import { LaunchesDate } from "../launchesDate.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";



export class LaunchesDateSerializer extends BaseSerializer {

    public deserialize( data: any ): any {

        const gp = new LaunchesDate();

        this._copyAttributes(gp, data);

        return gp;

    }

}
